<template>
  <div>
    <template v-if="!$store.state.ui.os.isPC">
      <div ref="wrapper" class="wrapperPhone">
        <div :style="{ width: 100 * list.length + 'px', display: 'flex', height: '100px', alignItems: 'center' }">
          <el-card :class="{ transparentBG: index !== 0 }" v-for="(item, index) in list" :key="index" style="overflow: visible !important;width: 100px;height: 78px;margin: 0 10px;position: relative;display: flex;align-items: center;cursor: pointer;" :body-style="{ padding: '0px' }">
            <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-conent: center;">
              <el-image lazy @click="clickImage(index)" :src="item.src" fit="contain" style="width: 100%"></el-image>
            </div>
            <el-button v-if="index !== 0" style="position: absolute;right: -10px;top: -10px;" size="small" type="primary" icon="el-icon-delete" circle @click="clickDelete(index)" />
          </el-card>
        </div>
      </div>
    </template>
    <template v-else>
      <div ref="wrapper" class="wrapper">
        <div :style="{ width: 100 * list.length + 'px', display: 'flex', height: '100px', alignItems: 'center' }">
          <el-card :class="{ transparentBG: index !== 0 }" @mouseenter="item.delete = true" @mouseleave="item.delete = false" v-for="(item, index) in list" :key="index" style="width: 100px;height: 78px;margin: 0 10px;position: relative;display: flex;align-items: center;cursor: pointer;" :body-style="{ padding: '0px' }">
            <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-conent: center;">
              <el-image lazy @click="clickImage(index)" :src="item.src" fit="contain" style="width: 100%"></el-image>
            </div>
            <el-button v-if="index !== 0 && item.delete" style="position: absolute;right: 0;top: 0;" size="small" type="primary" :icon="Delete" circle @click="clickDelete(index)" />
          </el-card>
        </div>
      </div>
    </template>
    <input ref="input" type="file" class="hidden" @change="inputChange">
  </div>
</template>

<script>
import BetterScroll from 'better-scroll'
import { getItem, setItem } from '@/utils/Utils.js'
import ConvertFile from '@/utils/ConvertFile.js'
import { Message } from 'element-ui'

export default {
  data () {
    return {
      list: [],
      bs: null
    }
  },
  watch: {
    async '$store.state.ui.initImageHistory' (val) {
      if (val) {
        await this.getHistory()
        if (this.bs == null) {
          this.initBS()
        } else {
          this.bs.refresh()
        }
        this.$store.state.ui.initImageHistory = false
      }
    },
    async '$store.state.ui.addImageHistory' (val) {
      if (val) {
        let tempList = []
        const cache = await getItem('IMAGE_HISTORY_V1')
        if (cache) {
          tempList = JSON.parse(cache)
        }
        tempList.splice(0, 0, val.name)
        // 保存单张图片
        setItem(val.name, val.src)
        setItem('IMAGE_HISTORY_V1', JSON.stringify(tempList))
        this.$store.state.ui.addImageHistory = null
      }
    }
  },
  methods: {
    async getHistory () {
      const cache = await getItem('IMAGE_HISTORY_V1')
      this.list = [{
        name: 'input',
        src: require('@/assets/render/input.png'),
        delete: false
      }]
      if (cache != null) {
        const arr = JSON.parse(cache)
        for (const item of arr) {
          this.list.push({
            name: item,
            src: await getItem(item),
            delete: false
          })
        }
      }
    },
    async setHistory () {
      const newList = this.list.filter(item => item.name !== 'input').map(item => { return item.name })
      await setItem('IMAGE_HISTORY_V1', JSON.stringify(newList))
    },
    async addItem (name, src) {
      // 保存单张图片
      setItem(name, src)
      this.list.splice(1, 0, {
        name,
        src,
        delete: false
      })
      this.setHistory()
      await this.$nextTick()
      if (this.bs) {
        this.bs.refresh()
      }
      this.$emit('select', {
        name,
        src
      })
    },
    inputChange (e) {
      const file = e.target.files[0]
      if (file) {
        const convert = new ConvertFile(file, async (e) => {
          if (e.msg === 'success') {
            this.addItem(e.name, e.data)
          } else {
            console.log('转换失败', e.msg, e.data)
            Message({
              message: 'Failed to import image',
              type: 'error'
            })
            // ElMessage.error('Failed to import image')
          }
        })
        convert.start()
      }
    },
    async clickDelet (index) {
      this.list.splice(index, 1)
      this.setHistory()
      await this.$nextTick()
      if (this.bs) {
        this.bs.refresh()
      }
    },
    clickImage (index) {
      if (index === 0) {
        if (this.$refs.input) {
          this.$refs.input.click()
        }
      } else {
        this.$emit('select', {
          name: this.list[index].name,
          src: this.list[index].src
        })
      }
    },
    initBS () {
      if (!this.$refs.wrapper) return
      this.bs = new BetterScroll(this.$refs.wrapper, {
        scrollX: true,
        scrollY: false,
        bounce: true,
        click: true
      })
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  width: 350px;
  height: 100px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.wrapperPhone {
  width: 90vw;
  height: 100px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.transparentBG {
  background: #cccccc;
  background-image: linear-gradient(45deg, #f6fafc 25%, transparent 0), linear-gradient(45deg, transparent 75%, #f6fafc 0), linear-gradient(45deg, #f6fafc 25%, transparent 0), linear-gradient(45deg, transparent 75%, #f6fafc 0);
  background-position: 0 0, 5px 5px, 5px 5px, 10px 10px;
  background-size: 10px 10px;
}
</style>
